import { useLocation } from 'react-router-dom';

import { ADMIN_ROUTE_PATH, ADMIN_ROUTE_RELATIVE_PATH } from '@/administration/constants/adminRoutePaths';

/**
 * Routes that should hide the footer
 * Add new routes here as needed
 */
const FOOTER_HIDDEN_ROUTES = [
  // Journey edit learnings route
  new RegExp(`^${ADMIN_ROUTE_PATH.JOURNEYS}/\\d+/${ADMIN_ROUTE_RELATIVE_PATH.JOURNEY_EDIT_LEARNINGS}$`),
  // Add more routes here as needed, for example:
  // new RegExp(`^${ADMIN_ROUTE_PATH.SOME_OTHER_ROUTE}/\\d+/some-sub-route$`),
];

/**
 * Custom hook to check if the footer should be hidden for the current route
 * @returns true if footer should be hidden, false otherwise
 */
export const useFooterVisibility = (): boolean => {
  const location = useLocation();
  return FOOTER_HIDDEN_ROUTES.some((regex) => regex.test(location.pathname));
};
